import {BoundingBox} from '@phosphor-icons/react'
import clsx from 'clsx'
import React, {useCallback, useEffect, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import {DndProvider, useDrag} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'
import {useFormContext, useWatch} from 'react-hook-form'
import Swal from 'sweetalert2'
import {ERROR_MESSAGE_SYSTEM, SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import {ShowSnackBar} from '../../../../../../util/functions'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import {useAssigment} from '../../../../hooks/limpieza/useAssigment'
import {
  AssigmentModel,
  CreatePhoneAssigmentModel,
  CreateScheduleAssigmentModel,
  LayoutModelDto,
} from '../../../../model/assigment.model'
import {
  createPhoneAssigment,
  createScheduleAssigment,
} from '../../../../services/assigment.services'
import {ViewAssignLayout} from './ViewAssIgnLayout'
import style from './index.module.scss'

interface ICampamento {
  CampamentoId: string
  CampamentoNombre: string
  TotalModulos?: number | 0
  TotalHabitaciones?: number | 0
  TotalCelulares?: number | 0
  TotalActividades?: number | 0
}

interface ICelular {
  Id: string
  NumeroCelular: string
  ProveedorServicio: string
  Modelo: string
  Marca: string
  Serie: string
  CampamentoId?: string | ''
  CampamentoNombre?: string | ''
}

interface IActividad {
  Id: string
  Descripcion: string
}

interface IListaCampamentoItem {
  campamento: ICampamento
  listaCelulares: ICelular[]
  listaActividades: IActividad[]
}

interface IListaCampamentos extends Array<IListaCampamentoItem> {}

const listaCampamentosInicial: IListaCampamentos = [
  {
    campamento: {CampamentoId: '1', CampamentoNombre: 'Campamento A'},
    listaCelulares: [
      //{ Id: '1', NumeroCelular: '+51 974 123 456', ProveedorServicio: 'Claro', Modelo: 'A50', Marca: 'SAMSUNG', Serie: 'A50SAN' },
    ],
    listaActividades: [
      //{ Id: '1', Descripcion: 'Moppeo pisos' },
    ],
  },
  {
    campamento: {CampamentoId: '2', CampamentoNombre: 'Campamento B'},
    listaCelulares: [
      // { Id: '1', NumeroCelular: '+51 974 123 456', ProveedorServicio: 'Claro', Modelo: 'A50', Marca: 'SAMSUNG', Serie: 'A50SAN' },
    ],
    listaActividades: [
      // { Id: '1', Descripcion: 'Moppeo pisos' },
    ],
  },
]

const listaCelularesInicial: ICelular[] = [
  {
    Id: '1',
    NumeroCelular: '+51 974 123 456',
    ProveedorServicio: 'Claro',
    Modelo: 'A50',
    Marca: 'SAMSUNG',
    Serie: 'A50SAN',
  },
  {
    Id: '2',
    NumeroCelular: '+51 974 123 457',
    ProveedorServicio: 'Movistar',
    Modelo: 'Mate X4',
    Marca: 'HUAWEI',
    Serie: 'MATX4H',
  },
]
const listaActividadesInicial: IActividad[] = [
  {Id: '1', Descripcion: 'Moppeo pisos'},
  {Id: '2', Descripcion: 'Barrido pisos'},
  {Id: '3', Descripcion: 'Limpieza ventanas'},
]

const ItemTypes = {
  PROGRAMACION: 'programacion',
}

const DraggableSchedule = ({
  programacion,
  index,
  programaciones,
  selectedIds,
  setSelectedIds,
  lastSelectedIndex,
  setLastSelectedIndex,
  tipoData,
}: any) => {
  // const isActivo = !celular.EsAsignado
  const isSelected = (selectedIds || []).includes(programacion.ServiceSchedulingId)
  const {selectedSchedules} = useAssigment()
  const isPicked = selectedSchedules.some(
    (p) => p.ServiceSchedulingId === programacion.ServiceSchedulingId,
  )
  let numeroAsignados = 0
  if (tipoData === 'CAP') {
    numeroAsignados =
      new Set(
        programacion?.Asignaciones?.filter((a) => a.CampamentoId !== null)?.map(
          (a) => a.CampamentoId,
        ),
      ).size || 0
  } else if (tipoData === 'MOD') {
    numeroAsignados =
      new Set(
        programacion?.Asignaciones?.filter((a) => a.ModuloId !== null)?.map((a) => a.ModuloId),
      ).size || 0
  } else if (tipoData === 'PIS') {
    numeroAsignados =
      new Set(programacion?.Asignaciones?.filter((a) => a.PisoId !== null)?.map((a) => a.PisoId))
        .size || 0
  } else if (tipoData === 'HAB') {
    numeroAsignados =
      new Set(
        programacion?.Asignaciones?.filter((a) => a.HabitacionId !== null)?.map(
          (a) => a.HabitacionId,
        ),
      ).size || 0
  }

  const selectedProgramaciones = programaciones.filter((p) =>
    selectedIds.includes(p.ServiceSchedulingId),
  )

  const [{isDragging}, dragRef] = useDrag(
    () => ({
      type: ItemTypes.PROGRAMACION,

      item: () => ({
        programacionesId: isSelected ? selectedIds : [programacion.ServiceSchedulingId],
        programaciones: isSelected ? selectedProgramaciones : [programacion],
      }),

      canDrag: true,

      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [selectedIds, isSelected],
  )

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    // if (!isActivo) return

    // SHIFT (rango)
    if (e.shiftKey && lastSelectedIndex !== null) {
      const start = Math.min(lastSelectedIndex, index)
      const end = Math.max(lastSelectedIndex, index)

      const rangeIds = programaciones
        .slice(start, end + 1)
        // .filter((c) => !c.EsAsignado)
        .map((c) => c.ServiceSchedulingId)

      setSelectedIds(rangeIds)
      return
    }

    // CTRL (multi select)
    if (e.ctrlKey) {
      setSelectedIds((prev) =>
        prev.includes(programacion.ServiceSchedulingId)
          ? prev.filter((x) => x !== programacion.ServiceSchedulingId)
          : [...prev, programacion.ServiceSchedulingId],
      )
      setLastSelectedIndex(index)
      return
    }

    // Click normal
    setSelectedIds([programacion.ServiceSchedulingId])
    setLastSelectedIndex(index)
  }

  return (
    <div
      ref={dragRef}
      onClick={handleClick}
      className={clsx('p-2 mb-2 rounded border select-none', {
        'border-blue-500 cursor-move': isSelected,
        [style.bgPicked]: isPicked,
        [style.bgSelected]: isSelected,
        // 'bg-white border-gray-300 cursor-move': isActivo && !isSelected,
        // 'bg-gray-300 border-gray-200 cursor-not-allowed opacity-60': !isActivo,
        'opacity-50': isDragging,
      })}
    >
      🗓️ {programacion.Nomenclatura} {numeroAsignados > 0 && `(${numeroAsignados})`}
    </div>
  )
}

const TotalComponent = ({
  setDataGroup,
  setIsReset,
  isReset,
  dataGroup,
  handleOpenActividades,
  handleOpenCelulares,
  handleAsignar,
  data,
  tipoData,
  loadModulesLayout,
  loadFloorsLayout,
  loadHabiationsLayout,
  selectedOptionName,
  selectedOption,
  loadCampsLayout,
  isLoadingLayout,
}: any) => {
  const [listaCampamentos, setListaCampamentos] =
    useState<IListaCampamentos>(listaCampamentosInicial)
  const [listaCelulares, setListaCelulares] = useState<ICelular[]>(listaCelularesInicial)
  const [listaActividades, setListaActividades] = useState<IActividad[]>(listaActividadesInicial)
  const [toggleListaDisponibles, setToggleListaDisponibles] = useState<boolean>(false) // false = celulares, true = actividades
  const [selectedIds, setSelectedIds] = useState<number[]>([])
  const [lastSelectedIndex, setLastSelectedIndex] = useState<number | null>(null)
  const {setValue, watch} = useFormContext()

  const handleBackgroundClick = () => {
    setSelectedIds([])
  }

  const {
    getProgramacionesDisponibles,
    programacionesDisponibles,
    loadingProgramaciones,
    getLayout,
  } = useAssigment()
  useEffect(() => {
    if (isReset) {
      setIsReset(false)
      setListaCampamentos(listaCampamentosInicial)
      setListaCelulares(listaCelularesInicial)
      setListaActividades(listaActividadesInicial)
    }
  }, [isReset, setIsReset])

  const handleDrop = (dto: CreateScheduleAssigmentModel) => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: `De asignar los celulares`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, asignar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              var {data: response} = await createScheduleAssigment(dto)
              if (!response.error) {
                ShowSnackBar(response.message ?? SUCCESS_MESSAGE_CREATE, 'success')
                if (dto.NivelAsignacion === 'CAP' || dto.NivelAsignacion === 'CAP-ALL') {
                  getLayout({
                    TipoData: 'CAP',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                } else if (dto.NivelAsignacion === 'MOD' || dto.NivelAsignacion === 'MOD-ALL') {
                  getLayout({
                    TipoData: 'MOD',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    CampamentoId: watch('CampamentoId'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                } else if (dto.NivelAsignacion === 'PIS' || dto.NivelAsignacion === 'PIS-ALL') {
                  getLayout({
                    TipoData: 'PIS',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    ModuloId: watch('ModuloId'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                } else if (dto.NivelAsignacion === 'HAB' || dto.NivelAsignacion === 'HAB-ALL') {
                  getLayout({
                    TipoData: 'HAB',
                    CompaniaId: watch('CompaniaIdCurrent'),
                    ClienteId: watch('ClienteIdCurrent'),
                    SiteId: watch('SiteIdCurrent'),
                    PisoId: watch('PisoId'),
                    TipoEdificacionId: watch('TipoEdificacionIdCurrent'),
                  })
                }
                const dtoProgramaciones = {
                  ClienteId: watch('ClienteIdCurrent'),
                  CompaniaId: watch('CompaniaIdCurrent'),
                  SiteId: watch('SiteIdCurrent'),
                  CampamentoId: watch('CampamentoId') || '',
                  pageNumber: 1,
                  size: 10000,
                }
                getProgramacionesDisponibles(dtoProgramaciones)
                setSelectedIds([])
              } else {
                ShowSnackBar(response.message ?? ERROR_MESSAGE_SYSTEM, 'error')
              }
            } catch (error) {
              // setLoadingCompleteStays(false)
              ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
            }
            Swal.close()
          } else if (result.isDenied) {
          }
        })
        .catch((error) => {
          // setLoadingCompleteStays(false)
          getSnackBarToast('Hubo un error ', 'error')
          console.log(error)
        })
    } catch (error) {
      // setLoadingCompleteStays(false)
      getSnackBarToast('Hubo un error ', 'error')
      console.log(error)
    }
  }

  const siteId = useWatch({name: 'SiteIdCurrent'})
  const campamentoId = useWatch({name: 'CampamentoId'})

  useEffect(() => {
    if (siteId) {
      const dto = {
        ClienteId: watch('ClienteIdCurrent'),
        CompaniaId: watch('CompaniaIdCurrent'),
        SiteId: watch('SiteIdCurrent'),
        CampamentoId: watch('CampamentoId') || '',
        pageNumber: 1,
        size: 10000,
      }
      setSelectedIds([])
      getProgramacionesDisponibles(dto)
    }
  }, [siteId, campamentoId])

  return (
    <DndProvider backend={HTML5Backend}>
      <div className='row '>
        <div className='col-9'>
          <ViewAssignLayout
            data={data}
            loadCampsLayout={loadCampsLayout}
            selectedOptionName={selectedOptionName}
            selectedOption={selectedOption}
            tipoData={tipoData}
            loadModulesLayout={loadModulesLayout}
            loadFloorsLayout={loadFloorsLayout}
            loadHabiationsLayout={loadHabiationsLayout}
            isLoadingLayout={isLoadingLayout}
            handleDrop={handleDrop}
          />
        </div>
        <div className='col-3'>
          <div className='p-6 sticky-top'>
            <div className='card card-custom shadow-sm'>
              <div className='card-header' style={{borderBottomWidth: '3px'}}>
                <div className='py-5 d-flex flex-wrap'>
                  <h4 className='d-flex align-items-center'>
                    <BoundingBox className='me-2 text-muted' size={32} weight='duotone' />
                    Programaciones
                  </h4>
                </div>
              </div>
              <div className='card-body' onClick={handleBackgroundClick}>
                {loadingProgramaciones ? (
                  <div className='p-6'>
                    <div className='d-flex justify-content-center align-items-center mb-2'>
                      <Spinner animation='border' />
                    </div>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      Cargando
                    </div>
                  </div>
                ) : programacionesDisponibles.length === 0 ? (
                  <div className='p-6'>
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                      No hay información
                    </div>
                  </div>
                ) : (
                  programacionesDisponibles.map((prog, index) => (
                    <div key={prog.ServiceSchedulingId}>
                      <DraggableSchedule
                        programacion={prog}
                        index={index}
                        programaciones={programacionesDisponibles}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        lastSelectedIndex={lastSelectedIndex}
                        setLastSelectedIndex={setLastSelectedIndex}
                        tipoData={tipoData}
                      />
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </DndProvider>
  )
}

const TotalComponentWrapper = ({
  setDataGroup,
  setIsReset,
  isReset,
  dataGroup,
  handleOpenActividades,
  handleOpenCelulares,
  handleAsignar,
  data,
  tipoData,
  loadModulesLayout,
  loadFloorsLayout,
  loadHabiationsLayout,
  selectedOptionName,
  selectedOption,
  loadCampsLayout,
  isLoadingLayout,
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <TotalComponent
        setDataGroup={setDataGroup}
        setIsReset={setIsReset}
        isReset={isReset}
        dataGroup={dataGroup}
        handleOpenActividades={handleOpenActividades}
        handleOpenCelulares={handleOpenCelulares}
        handleAsignar={handleAsignar}
        data={data}
        tipoData={tipoData}
        loadModulesLayout={loadModulesLayout}
        loadFloorsLayout={loadFloorsLayout}
        loadHabiationsLayout={loadHabiationsLayout}
        selectedOptionName={selectedOptionName}
        selectedOption={selectedOption}
        loadCampsLayout={loadCampsLayout}
        isLoadingLayout={isLoadingLayout}
      />
    </DndProvider>
  )
}

export {TotalComponentWrapper}
